import {Service} from "vue-typedi";
import {fabricationApiClient} from "@/configuration/api-client";
import {Support, SupportStatuses} from "@/model/support/Support";
import {CreateSupportRequest} from "@/model/support/CreateSupportRequest";
import {ConfirmOrderPreparationRequest} from "@/model/ConfirmOrderPreparationRequest";
import {SupportProduct} from "@/model/support/SupportProduct";

@Service()
export class SupportService {

  public static SUPPORTS_ENDPOINT: string = "/supports";
  public static EXISTS_SUPPORT_PATH: string = "/exists";
  public static DROP_OFF_PATH: string = "/drop-off";
  public static COLLECT_PATH: string = "/collect";
  public static PREPARE_FOR_COLLECTION_PATH: string = "/prepare";
  public static CONFIRM_DROP_OFF_PATH: string = "/drop-off/confirm";
  public static CONFIRM_PREPARATION_PATH: string = "/preparation/confirm";
  public static UPDATE_PRODUCT_PATH: string = "/products";
  public static ORDER_PATH: string = "/order";
  private static readonly STORE_ID: string = "storeId";

  public getCollectedSupports(): Promise<Support[]>  {
    const params = {
      storeId: sessionStorage.getItem(SupportService.STORE_ID),
      status: [SupportStatuses.COLLECTED, SupportStatuses.DROPPED_OFF].join(",")
    };

    return fabricationApiClient.get(SupportService.SUPPORTS_ENDPOINT, { params })
      .then((response: any) => {
        const supports: Support[] = response?.data ?? [];
        return Promise.resolve(supports);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public existsSupport(supportCode: string): Promise<boolean>  {
    const params = {
      storeId: sessionStorage.getItem(SupportService.STORE_ID),
    };

    return fabricationApiClient.get(`${SupportService.SUPPORTS_ENDPOINT}${SupportService.EXISTS_SUPPORT_PATH}/${supportCode}`, { params })
      .then((response: any) => {
        const existsSupport: boolean = response?.data ?? null;
        return Promise.resolve(existsSupport);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public async createSupport(createSupportRequest: CreateSupportRequest): Promise<Support> {
    try {
      const response = await fabricationApiClient.post(SupportService.SUPPORTS_ENDPOINT, createSupportRequest);
      const supports: Support = response?.data ?? null;
      return Promise.resolve(supports);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async deleteSupport(supportId: string): Promise<void> {
    try {
      await fabricationApiClient.delete(`${SupportService.SUPPORTS_ENDPOINT}/${supportId}`);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getSupportsByOrderNumberAndZoneCode(orderNumber: string, zoneCode: string): Promise<Support[]> {
    const response = await fabricationApiClient.get(`${SupportService.SUPPORTS_ENDPOINT}${SupportService.ORDER_PATH}/${orderNumber}/${zoneCode}`);

    return response?.data ?? [];
  }

  public async updateSupportProducts(support: Support, products: SupportProduct[]): Promise<void> {
    const storeId = sessionStorage.getItem(SupportService.STORE_ID);
    try {
      await fabricationApiClient.post<Support>(
        `${SupportService.SUPPORTS_ENDPOINT}/${support.code}${SupportService.UPDATE_PRODUCT_PATH}`,
        products,
        { params: { storeId } }
      );
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public getCreatedSupports(): Promise<Support[]>  {
    const params = {
      storeId: sessionStorage.getItem(SupportService.STORE_ID),
      status: [SupportStatuses.COLLECTED, SupportStatuses.TO_COLLECT].join(",")
    };

    return fabricationApiClient.get(SupportService.SUPPORTS_ENDPOINT, { params })
      .then((response: any) => {
        const supports: Support[] = response?.data ?? [];
        return Promise.resolve(supports);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public dropOffSupport(supportCode: string, dropOffLocation: string): Promise<Support>  {
    const body = {
      supportCode,
      dropOffLocation: dropOffLocation?.trim(),
      storeId: sessionStorage.getItem(SupportService.STORE_ID)
    };

    return fabricationApiClient.post(SupportService.SUPPORTS_ENDPOINT + SupportService.DROP_OFF_PATH , body)
      .then((response: any) => {
        const supports: Support = response?.data ?? null;
        return Promise.resolve(supports);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public collectSupport(supportCode: string, collectionSlot: Date): Promise<Support>  {
    const body = {
      supportCode,
      collectionSlot,
      storeId: sessionStorage.getItem(SupportService.STORE_ID)
    };

    return fabricationApiClient.post(SupportService.SUPPORTS_ENDPOINT + SupportService.COLLECT_PATH , body)
      .then((response: any) => {
        const supports: Support = response?.data ?? null;
        return Promise.resolve(supports);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public prepareSupportForCollection(supportCode: string): Promise<Support>  {
    const storeId = sessionStorage.getItem(SupportService.STORE_ID);

    return fabricationApiClient.post(`${SupportService.SUPPORTS_ENDPOINT}${SupportService.PREPARE_FOR_COLLECTION_PATH}/${supportCode}`,
      {},
      { params: { storeId } })
      .then((response: any) => {
        const supports: Support = response?.data ?? null;
        return Promise.resolve(supports);

      }).catch((error) => {
        return Promise.reject(error);
      });
  }

  public confirmDropOffSupport(support: Support): Promise<void>  {
    return fabricationApiClient.post(SupportService.SUPPORTS_ENDPOINT + SupportService.CONFIRM_DROP_OFF_PATH , support)
      .then(() => {})
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  public confirmPreparationSupports(request: ConfirmOrderPreparationRequest): Promise<void> {
    return fabricationApiClient.post(
      SupportService.SUPPORTS_ENDPOINT + SupportService.CONFIRM_PREPARATION_PATH,
      request
    );
  }

}